/**
 * サービス概要セクションの背景画像パララックス効果
 * GSAP ScrollTrigger を使用して滑らかな視差効果を実装
 * 
 * @package LIVMO
 * @version 2.0.0
 */

(function() {
  'use strict';


  function initWhenReady() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(initWhenReady, 50);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initParallax);
    } else {
      initParallax();
    }
  }

  function initParallax() {
      // service-overviewとservice-real-estate-overviewの両方に対応
    const sections = document.querySelectorAll('.service-overview__background, .service-real-estate-overview__background');

    if (sections.length === 0) {
        return;
      }

    sections.forEach((section, index) => {
      const bg = section.querySelector('.service-overview__background-image, .service-real-estate-overview__background-image');
        
      if (!bg) {
          return;
        }

      gsap.to(bg, {
        y: 50,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 0.6,
          invalidateOnRefresh: true
        }
      });
      });
      
  }

  // 初期化開始
  initWhenReady();

})();
